import React from 'react'

import { TtIcon } from '@23/react'

import './FocusPreviewTraySlides.scss'

const FocusPreviewTraySlides = () => {
  return (
    <div className="focus-preview-tray-slides">
      <div className="focus-preview-tray-slides-before" />
      <div className="focus-preview-tray-slides-slide">
        <TtIcon library="one/webinars" name="tray-closed" />
      </div>
      <div className="focus-preview-tray-slides-after" />
    </div>
  )
}

export { FocusPreviewTraySlides }
